module.exports = __webpack_public_path__ + "img/admin-contactos.f0a4dde1.svg";